import { Translate } from "components/common/Translate/Translate";
import JpegCompressorTutorialSvg from "components/common/Resources/JpegCompressorTutorialSVG";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";
import ImageConverterTutorialSvg from "components/common/Resources/ImageConverterTutorialSVG";
import {ReactNode} from "react";

interface JpegPngCompressorTutorialProps {
    template: ImageConverterPageTemplateInterface;
    variables?: Record<any, any>;
    graphics?: ReactNode
}

export const ImageConverterSection4Tutorial = (props: JpegPngCompressorTutorialProps) => {
    const section4 = props.template["section4"];
    const variables = props.variables;

    return (
        <div className="flex flex-col md:flex-row w-full  dark:text-white py-24 md:py-36 mt-[72px] items-center justify-center content-center bg-[#EEEEEE] dark:bg-gray-800 px-6 md:px-10">
            {/*right*/}
            <div className="flex justify-center content-center items-center">
                {   props.graphics || <ImageConverterTutorialSvg />}
            </div>

            {/*left*/}
            <div className="mt-16 md:mt-0 w-full md:w-auto md:pl-[84px]">
                {/* header */}
                <h2 className="font-semibold sub-heading mb-10  md:text-start">
                    <Translate keyName={section4.title} variables={variables} />
                </h2>
                {/* tutorial points */}
                <ol className="flex flex-col gap-6 list-decimal marker:font-semibold pl-4">
                    {section4["subTexts"].map((text, index) => {
                        return (
                            <li key={index} className="">
                                <span className="pl-1">
                                    <Translate keyName={text} variables={variables}/>
                                </span>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};
